import React from "react";
import "./profile.css";
import {CloudDownloadSharp} from "@mui/icons-material"
import photo from "./Ahmed 2.png";
import phone from "./icons/phone.png";
import email from "./icons/email.png";
import birthdate from "./icons/birthdate.png";
import location from "./icons/location.png";
import github from "./icons/github.png";
import linkedin from "./icons/linkedin.png";
import cv from "./Ahmed Sayed-CV.pdf";

export default function Profile() {
  return (
    <>
      <section className="leftSection">
        <div className="imageContainer">
          <img
            src={photo}

            alt="profile"
            className="profileImage"
          />
        </div>
        <h2> Ahmed Sayed</h2>
        <div className="profession">
          <p>Software Engineer</p>
        </div>
        <div className="social">
          <div className="linkedIn">
            <a
              href="https://www.linkedin.com/in/ahmeedsayed/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="linkedin" width={25} height={25} />
            </a>
          </div>
          <div className="github">
            <a
              style={{ textDecoration: "none", color: "white" }}
              href="https://github.com/Ahmeed-Sayed"
              target="_blank"
              rel="noreferrer"
            >
              <img src={github} alt="github" width={25} height={25} />
            </a>
          </div>
        </div>
        <div className="info">
          <div className="infoSection">
            <div className="icon">
              <img src={phone} width={25} height={25} alt="phone icon" />{" "}
            </div>
            <div className="sectionDetails">
              <p className="label">Phone</p>
              <p className="detail">+20 109 137 9361</p>
            </div>
          </div>
          <div className="infoSection">
            <div className="icon">
              <img src={email} width={25} height={25} alt="email icon" />
            </div>
            <div className="sectionDetails">
              <p className="label">Email</p>
              <p className="detail">ahmeedsayed01@gmail.com</p>
            </div>
          </div>
          <div className="infoSection">
            <div className="icon">
              <img src={location} width={25} height={25} alt="location icon" />
            </div>
            <div className="sectionDetails">
              <p className="label">Location</p>
              <p className="detail">Qalyub, Al-Qalyubiah, Egypt</p>
            </div>
          </div>
          <div className="infoSection" style={{ borderBottom: 0 }}>
            <div className="icon">
              <img
                src={birthdate}
                width={30}
                height={30}
                alt="birthdate icon"
              />
            </div>
            <div className="sectionDetails">
              <p className="label">Birthdate</p>
              <p className="detail">Sep 30, 1998</p>
            </div>
          </div>
        </div>

        <div className="downloadCVContainer">
          <a href={cv} download>
            <div className="downloadCVDetails">
              <span className="downloadIcon">
                <CloudDownloadSharp />
              </span>
              <span>Download CV</span>
            </div>
          </a>
        </div>
      </section>
    </>
  );
}
